import React from "react";
import "../scss/pickupDrop.css";
import pickupImage from "../images/MotoDoctor_Pickup_Drop_624x624.png";

const PickupDrop = () => {
  return (
    <section className="pickup-drop">
      <div className="container">
        <h2 className="title">MotoDoctor Pickup and Drop Service</h2>
        <p className="description">
          MotoDoctor’s Pickup and Drop service is designed to make motorcycle maintenance and repairs as convenient as
          possible. Whether your bike needs routine service, repairs after a breakdown, or transport to another
          location, our team will handle everything from start to finish.
        </p>
        <p className="description">
          We pick up your motorcycle from your desired location, transport it securely to our service centre or your
          chosen destination, and drop it back to you once the work is done.
        </p>
        <div className="image-container">
          <img src={pickupImage} alt="Bike being towed" className="service-image" />
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(360px, 1fr))",
            gap: "32px",
            marginTop: "40px",
          }}
        >
          <div
            style={{
              background: "#ffffff",
              borderRadius: "18px",
              padding: "36px",
              boxShadow: "0 12px 32px rgba(0, 0, 0, 0.12)",
              borderLeft: "6px solid #ff7a00",
            }}
          >
            <h3
              style={{
                fontSize: "24px",
                fontWeight: "700",
                color: "#0b1c2d",
                marginBottom: "16px",
              }}
            >
              Booking Options
            </h3>
            <p
              style={{
                fontSize: "17px",
                color: "#444",
                lineHeight: "1.8",
                margin: 0,
              }}
            >
              Easily book the service through our mobile app with flexible options to schedule a pickup at your
              preferred time and location.
            </p>
          </div>

          <div
            style={{
              background: "#ffffff",
              borderRadius: "18px",
              padding: "36px",
              boxShadow: "0 12px 32px rgba(0, 0, 0, 0.12)",
              borderLeft: "6px solid #0b1c2d",
            }}
          >
            <h3
              style={{
                fontSize: "24px",
                fontWeight: "700",
                color: "#0b1c2d",
                marginBottom: "16px",
              }}
            >
              Service Areas
            </h3>
            <p
              style={{
                fontSize: "17px",
                color: "#444",
                lineHeight: "1.8",
                margin: 0,
              }}
            >
              Currently available across Chennai, with rapid expansion plans to serve more cities and regions in the
              near future.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PickupDrop;
